




































































































import Vue from 'vue';
import { mapState } from 'vuex';
import { Mutation } from 'vuex-class';
import {
  Component, Watch, Inject,
} from 'vue-property-decorator';
import {
  Alert,
  NoticeClass,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import DisclaimerFooter from '@/components/DisclaimerFooter.vue';
import QuestionCard from '@/components/QuestionCard.vue';
import { Graph, Node } from '@/api/graph/';
import { Settings, SettingsResource } from '@/api/settings/';
import { AnswerMap } from '@/api/AnswerMap';
import { FriendlyAnswer } from '@/api/FriendlyAnswer';
import AnswerSummary from '@/components/AnswerSummary.vue';

@Component({
  computed: mapState(['fiId', 'graphMap', 'fiSettings']),
  components: {
    DisclaimerFooter, QuestionCard, AnswerSummary, KCardHeader,
  },
})
export default class SetupMainView extends Vue {
  fiId!: number;

  currentNode: Node | null = null;

  graphMap!: Map<string, Graph>;

  fiSettings!: Settings;

  @Inject('SettingsResource')
  settingsResource!: SettingsResource;

  @Mutation('fiSettings') mutationFiSettings: any;

  nodeHistory: string[] = [];

  currentAnswers: AnswerMap = {};

  progressPercentage: number = 0;

  showSummary: boolean = false;

  setupGraph: Graph | undefined | null = null;

  editMode: boolean = false;

  saving: boolean = false;

  loading: boolean = false;

    headerItems: any = [
      {
        text: 'RegGen',
        disabled: false,
        link: false,
      },
      {
        text: 'FI Setup',
        disabled: true,
      },
    ];

  @Watch('$route', { immediate: true, deep: true })
    onRouteChange() {
      this.loading = true;

      this.loadGraphIfNecessary();

      if (this.setupGraph) {
        this.currentNode = null;
        this.showSummary = false;

        if (Object.keys(this.currentAnswers).length < Object.keys(this.fiSettings).length) {
          Object.assign(this.currentAnswers, this.fiSettings.attributes);
        }

        if (this.setupGraph) {
          if (this.$route.name === 'setupSummary' && this.setupGraph.isTerminalPath(this.currentAnswers)) {
            this.nodeHistory = [];
            this.showSummary = true;
            this.loading = false;
          } else if (this.$route.params.nodeId) {
            const foundNode: Node | undefined = this.setupGraph.getNode(this.$route.params.nodeId);

            if (!foundNode) {
              this.showErrorMessage(`Node with id ${this.$route.params.nodeId} not found!`);
            } else if (this.nodeHistory.length === 0 && foundNode.id !== this.setupGraph.getEntryNode().id && this.currentAnswers[foundNode.id] === undefined) {
            // If we don't have node history, this isn't the first question, and there's no answer for it,
            // then we've tried to jump into the middle, so back out to the start.
              this.$router.push({ name: 'setupMain', params: { clientId: this.$route.params.clientId } });
            } else {
              this.showNode(foundNode);
              this.loading = false;
            }
          } else if (this.setupGraph.isTerminalPath(this.currentAnswers)) {
            this.goToSummary();
          } else {
            this.loading = false;
          }
        }
      }
    }

  loadGraphIfNecessary() {
    if (this.setupGraph == null) {
      this.setupGraph = this.graphMap.get('settings');
    }
    if (!this.setupGraph) {
      this.showErrorMessage('Settings question graph was not found!');
    }
  }

  showNode(node: Node) {
    this.currentNode = node;

    this.editMode = this.setupGraph!.isTerminalPath(this.currentAnswers);

    // If this node is in the history, trim it and everything after it.
    const historyPos:number = this.nodeHistory.indexOf(this.currentNode.id);
    if (historyPos !== -1) {
      this.nodeHistory.splice(historyPos);
    }

    this.progressPercentage = this.setupGraph!.getProgressPercentage(this.currentNode.id);
  }

  onStart() {
    if (this.setupGraph) {
      const entryNode = this.setupGraph.getEntryNode();
      this.goToNode(entryNode.id);
    }
  }

  onNext(value: string | string[]) {
    if (this.currentNode) {
      this.currentAnswers[this.currentNode.id] = value;
      this.nodeHistory.push(this.currentNode.id);

      if (this.setupGraph?.isTerminalPath(this.currentAnswers)) {
        this.saveSettings();
      } else {
        const nextNodeId: string | null = this.currentNode.getNextNode(this.currentAnswers);
        if (nextNodeId !== null) {
          this.goToNode(nextNodeId);
        } else {
          // Should never happen unless someone starts answering questions then manually changes the URL to skip forward,
          // but if we got to the end but haven't answered the complete set of questions, just bounce back to the start.
          this.currentNode = null;
        }
      }
    }
  }

  goToSummary() {
    this.$router.push({ name: 'setupSummary', params: { clientId: this.$route.params.clientId } });
  }

  saveSettings() {
    this.saving = true;

    this.settingsResource.save(this.fiId, this.buildSettingsObject()).then((newSettings:Settings) => {
      this.mutationFiSettings(newSettings);
      this.goToSummary();
    }).catch((error:any) => {
      this.showErrorMessage(error);
    }).finally(() => {
      this.saving = false;
    });
  }

  buildSettingsObject(): Settings {
    const friendlySettings: FriendlyAnswer[] = [];
    return {
      id: this.fiId,
      friendlySettings,
      attributes: this.currentAnswers,
    };
  }

  onBack() {
    if (this.currentNode && this.nodeHistory.length > 0) {
      this.goToNode(this.nodeHistory.pop()!);
    } else {
      this.$router.push({ name: 'setupMain', params: { clientId: this.$route.params.clientId } });
    }
  }

  goToNode(nodeId: string) {
    this.$router.push({ name: 'setupQuestion', params: { clientId: this.$route.params.clientId, nodeId } });
  }

  showErrorMessage(error: string) {
    console.error(error);
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
